import $ from 'jquery';
import Popup from './popup';
import * as Keys from './keys';

let popup;

function openPopup(e) {
  e.preventDefault();

  const $linkEl = $(e.currentTarget);
  popup.open({
    href: $linkEl.attr('href'),
    popupClass: $linkEl.data('popup-class'),
  });
}

function closePopup(e) {
  e.preventDefault();
  popup.close();
}

function closePopupFromWrap(e) {
  const $el = $(e.target);
  if ($el.is('.popup--wrap')) {
    closePopup(e);
  }
}

function closePopupIfEsc(e) {
  const key = e.keyCode;
  if (key === Keys.Esc && popup.isOpen) {
    closePopup(e);
  }
}

if (!window.popupInitialized) {
  // Hack for å sikre at popups bare initialiseres en gang.
  // Nødvendig pga. at popups lastes dynamisk.
  // TODO: Finn en bedre løsning på dette.
  window.popupInitialized = true;

  $(document).on('click', '[rel=popup]', openPopup);
  $(document).on('click', '.popup .popup--close', closePopup);
  $(document).on('dblclick', '.popup .popup--wrap', closePopupFromWrap);
  $(document).on('keydown', closePopupIfEsc);

  $(document).ready(() => {
    const popupEl = $('.popup');
    if (!popupEl.length) {
      console.error('No element with .popup found');
    }

    popup = new Popup(popupEl);

    window.getPopup = () => popup;
  });
}
